import { TableCell, TableRow } from '@hivewatch/dark'
import type { TableRowActivationEvent } from '@hivewatch/dark'

import type { RuleRowData, RuleTableColumn } from '../types/rulesTable'

interface DarkRulesTableRowIProps {
  columns: RuleTableColumn[]
  row: RuleRowData
  onRowClick: (
    id: string,
    isV2: boolean,
    event: TableRowActivationEvent
  ) => void
}

export const DarkRulesTableRow = ({
  columns,
  row,
  onRowClick,
}: DarkRulesTableRowIProps) => (
  <TableRow
    onAuxClick={(event) => {
      // Middle-click only; browsers also fire auxclick for the right button.
      if (event.button === 1) onRowClick(row.id, row.isV2, event)
    }}
    onClick={(event) => onRowClick(row.id, row.isV2, event)}
  >
    {columns.map((column) => (
      <TableCell
        align={column.align}
        flexGrow={column.flexGrow}
        key={`${row.id}-${column.key}`}
        maxWidth={column.maxWidth}
        minWidth={column.minWidth}
        width={column.width}
      >
        {column.cell(row)}
      </TableCell>
    ))}
  </TableRow>
)
